/**
 * The place where most of the custom JavaScript should be found.
 */


// Tiles BLock 
;( () => {

    const tilesBlock = document.querySelectorAll( '.block--tiles' );

    if( !tilesBlock ) {
        return;
    }

    tilesBlock.forEach( block => {

        const tiles = block.querySelectorAll( '.tile' );
       
        tiles.forEach( tile => {
            tile.addEventListener( 'mouseover', function() {
                tile.classList.add( 'tile--active' );
            })

            tile.addEventListener( 'mouseleave', function() {
                tile.classList.remove( 'tile--active' );
            } )

        })
    })
})();


// Pop Up Modal
;( () => {

    const popUpBtn = document.querySelectorAll( '.pop-up__read-more' )

    if( !popUpBtn ) {
        return;
    }

    const body = document.body

    popUpBtn.forEach( button => {

        button.addEventListener( 'click', function(e) {

            const modalIdentifier = button.getAttribute( 'aria-controls' )
            const popUp = document.querySelector( '#' + modalIdentifier );
            const closeModalBtn = popUp.querySelectorAll( '.pop-up__modal-close' )

            popUp.classList.add( 'modal--active' )
            popUp.setAttribute( 'aria-hidden', 'false' )
            body.classList.add( 'no-scroll' )

            closeModalBtn.forEach( modalClose => {
                modalClose.addEventListener( 'click', function() {
                    popUp.classList.remove( 'modal--active' )
                    popUp.setAttribute( 'aria-hidden', 'true' )
                    body.classList.remove( 'no-scroll' )

                })
            })

        })
    }) 

})();

// Page Pup Up

;( () => {

    const popUp = document.querySelector( '.popup-set' )

    if( !popUp ) {
        return;
    }

    const body = document.body

    const closeModalBtn = popUp.querySelector( '.pop-up__modal-close' )

    const popupId = popUp.getAttribute( 'id' )

    if( sessionStorage.getItem( 'popupID' ) === popupId ) {
         return 
    }

    popUp.classList.add( 'modal--active' )
    popUp.setAttribute( 'aria-hidden', 'false' )
    body.classList.add( 'no-scroll' )


    closeModalBtn.addEventListener( 'click', function() {
        popUp.classList.remove( 'modal--active' )
        popUp.setAttribute( 'aria-hidden', 'true' )
        body.classList.remove( 'no-scroll' )

    })

    sessionStorage.setItem( 'popupID', popupId )

})();


/**
 * Globally close a popup. (not popup-set)
 */
( () => {
    const popUps = document.querySelectorAll( '.pop-up-block__modal-wrapper:not(.popup-set)' )

    if ( !popUps.length ) {
        return
    }

    popUps.forEach( popUp => {
        const closeModalBtn = popUp.querySelector( '.pop-up__modal-close' )

        closeModalBtn.addEventListener( 'click', function() {
            popUp.classList.remove( 'modal--active' )
            popUp.setAttribute( 'aria-hidden', 'true' )
            document.body.classList.remove( 'no-scroll' )
    
        })
    })
})();


// Careers Form

;( () => {

    const formCareers = document.querySelector( '.shiftr-form--careers' );

    if( !formCareers ) { return }


    let params = ( new URL(document.location)).searchParams;

    if( !params ) { return }

    let career = params.get('career');

    if( !career ) { return }

    const select = formCareers.querySelector( '.form-select' )

    select.value = career;

})();


// Meetings & Events Form

;( () => {

    const formMeetingEvents = document.querySelector( '.shiftr-form--meeting_events' );

    if( !formMeetingEvents ) { return }


    let meetingParams = ( new URL(document.location)).searchParams;

    if( !meetingParams ) { return }

    let meeting_events = meetingParams.get('meeting-events');

    if( !meeting_events ) { return }

    const input = formMeetingEvents.querySelector( '.field-meeting_and_event input' )

    input.value = meeting_events;

})();



/**
 * Booking Form
 */
( () => {
    const form = document.querySelector( '.hero-booking-form' )

    if ( !form ) {
        return
    }

    function hideBookingTypeActions() {
        document.querySelectorAll( '[data-booking-type]' ).forEach( el => {
            el.style.display = 'none'
        })
    }

    function hideRestaurantActions() {
        document.querySelectorAll( '[data-restaurant-selector]' ).forEach( el => {
            el.style.display = 'none'
        })
    }

    function showBookingTypeAction( type ) {
        form.booking_type.value = `booking-type-${ type }`

        const el = document.querySelector( `[data-booking-type="${ type }"]` )
        el.style.display = 'block'

        return el
    }

    function showRestaurantAction( type ) {
        form.restaurant_selector.style.display = 'block'
        form.restaurant_selector.value = type

        const el = document.querySelector( `[data-restaurant-selector="${ type }"]` )
        el.style.display = 'block'

        return el
    }

    form.booking_type.addEventListener( 'change', event => {
        hideBookingTypeActions()
        hideRestaurantActions()

        if ( event.target.value === 'booking-type-table' ) {
            form.restaurant_selector.style.display = 'block'
        } else {
            form.restaurant_selector.style.display = 'none'
        }

        const type = event.target.value.match( /([a-z]+)$/g )?.[0]
        const typeWrapper = showBookingTypeAction( type )
        
        typeWrapper.children[0].style.display = 'block'
    })


    form.restaurant_selector.addEventListener( 'change', event => {
        hideRestaurantActions()
        showRestaurantAction( event.target.value )
    })


    if ( document.body.classList.contains( 'front-page' ) ) {
        showBookingTypeAction( 'room' )
    } else if ( document.body.classList.contains( 'archive-meetings-events' ) ||
        document.body.classList.contains( 'archive-meetings-rooms' ) ||
        document.body.classList.contains( 'single-meetings-rooms' ) ) {
        showBookingTypeAction( 'meeting' )
    } else if ( document.body.classList.contains( 'archive-food-drink' ) ||
        document.body.classList.contains( 'food-drink_id-545' ) ) {
        showBookingTypeAction( 'table' )
        showRestaurantAction( 'book-food-quarterbar' )
    } else if ( document.body.classList.contains( 'food-drink_id-556' ) ) {
        showBookingTypeAction( 'table' )
        showRestaurantAction( 'book-food-londinium' )
    } else if ( document.body.classList.contains( 'food-drink_id-562' ) ) {
        showBookingTypeAction( 'table' )
        showRestaurantAction( 'book-food-afternoontea' )
    } else {
        showBookingTypeAction( 'room' )
    }

    [
        ...[...document.querySelectorAll( 'a[href*="#bookatable"]' )],
        ...[...document.querySelectorAll( 'a[href*="#bookafternoontea"]' )]
    ].filter( Boolean ).forEach( el => {
        el.addEventListener( 'click', event => {
            event.preventDefault()
    
            const modal = document.querySelector( '.pop-up-block__modal-wrapper#booking_table' )
            modal.querySelector( 'iframe' ).src = 'https://module.lafourchette.com/en_GB/module/596529-fe364'
            modal.classList.add( 'modal--active' )
        })
    });

    [
        ...[...document.querySelectorAll( 'a[href*="#book-londinium-table"]' )]
    ].forEach( el => {
        el.addEventListener( 'click', event => {
            event.preventDefault()

            const modal = document.querySelector( '.pop-up-block__modal-wrapper#booking_table' )

            modal.querySelector( 'iframe' ).src = 'https://module.lafourchette.com/en_GB/module/620957-59845'
            modal.classList.add( 'modal--active' )
        })
    })
})();

( () => {
    [
        document.querySelector( 'a[href*="virtual-tours"]' ),
        document.querySelector( '.block--directions .shiftr-accordion .shiftr-accordion__item:first-child .shiftr-accordion__tab' ),
    ].filter( Boolean ).forEach( el => {
        el.addEventListener( 'click', event => {
            event.preventDefault()

            let url = event.currentTarget.href

            if ( event.currentTarget.classList.contains( 'shiftr-accordion__tab' ) ) {
                url = `${shiftr.url}/virtual-tours/frontage_night/exterior_night.html`
            }

    
            const modal = document.querySelector( '.pop-up-block__modal-wrapper#view360tour' )

            modal.querySelector( 'iframe' ).src = url
            modal.classList.add( 'modal--active' )
        })
    })
})();

( () => {


    [
        ...document.querySelectorAll( 'a[href*="#socialmedia"]' )
    ].filter( Boolean ).forEach( el => {
        el.addEventListener( 'click', event => {
            event.preventDefault()

            closeMobileMenu();
    
            const modal = document.querySelector( '.pop-up-block__modal-wrapper#socialmedia' )

            modal.classList.add( 'modal--active' )

    
        })
    })

    function closeMobileMenu( event ) {
        // event.preventDefault()

        const   mobileMenu      = document.querySelector( '.mobile-menu' ),
                headerWrapper   = document.querySelector( '.header-wrapper' );
                body           = document.querySelector( 'body' );

        mobileMenu.setAttribute( 'aria-hidden', true )
        headerWrapper.classList.remove( 'mobile-menu-active' )
        body.classList.remove( 'no-scroll', 'overlay-active' )

        setTimeout( () => {
            window.removeEventListener( 'click', closeMobileMenu )
        }, 200 );

    }
    

})();


/**
 * Accommodation Video
 * 
 * Display a modoal containing th video player.
 */
( () => {
    const video = document.querySelector( '#accommodation-video' )

    if ( !video ) {
        return
    }

        const trigger = video.querySelector( 'button.video-trigger' )
        const modal = video.querySelector( '#accommodation-video-modal' )
        const closeButton = video.querySelector( '#accommodation-video-modal__close' )

        /**
         * Hide the video modal.
         */
        function hideModal() {
            document.body.classList.remove( 'no-scroll', 'overlay-active', 'overlay-active--black' )
            modal.classList.remove( 'is-visible' )
            modal.setAttribute( 'aria-hidden', true )

            const videoEl = modal.querySelector( 'video' )

            console.log( videoEl );

            if ( videoEl ) {
                videoEl.pause()
            }

            setTimeout( () => {
                window.removeEventListener( 'click', hideModal )
                window.removeEventListener( 'keyup', escHideModal )
            }, 100 )
        }

        /**
         * Hide the modal by pressing the escape key.
         * 
         * @param {KeyboardEvent} event 
         */
        function escHideModal( event ) {
            if ( event.key === 'Escape' ) {
                hideModal()
            }
        }

        trigger.addEventListener( 'click', () => {
            document.body.classList.add( 'no-scroll', 'overlay-active', 'overlay-active--dark' )
            modal.classList.add( 'is-visible' )
            modal.setAttribute( 'aria-hidden', false )

            console.log( modal.getAttribute('aria-hidden') );

            const videoEl = modal.querySelector( 'video' )

            if ( videoEl ) {
                videoEl.play()
            }

            setTimeout( () => {
                window.addEventListener( 'click', hideModal )
                window.addEventListener( 'keyup', escHideModal )
            }, 100 )
        })

        closeButton.addEventListener( 'click', hideModal )

})();